export const PAGE_ARTICLE = 'page_article';
export const PAGE_OFFRE = 'page_offre';
